import { computed, Injectable, OnDestroy, signal, WritableSignal } from '@angular/core';
import maplibregl from 'maplibre-gl';
import { Subscription } from 'rxjs';
import { WorkOrderBase } from '../../CommonFiles/BusinessModels';
import { ReadyForDispatchColor } from '../../CommonFiles/enums/workOrderDetails.enum';
import { WOStatusWeb } from '../../constants/woStatusOptions';
import { MapSharedUtilService } from '../../home/services/map-shared-util.service';
import { WorkorderGRPCService } from '../../ProxyServices/workorder.grpc.service';

@Injectable()
export class SpiderfyService implements OnDestroy {
  
  mappopupRef: maplibregl.Popup;
  closeMarker:any;
  isActive: boolean;
  isMouseOver: boolean = false; // this will be true when user is hovering over marker;
  isMarkerActive: boolean = false; // this will be true when user is hovering over marker;
  isTooltipActive: boolean = false; // this will be true when user is hovering over marker;

  
  
  selectedWorkOrders:WritableSignal<WorkOrderBase[]> = signal([]); 
  selectedSet = computed<Set<string>>(() => {
    const selectedSet = new Set(this.selectedWorkOrders().map(feature => feature.name));
    return selectedSet;
  }); 
  
  private subscriptions: Subscription[] = [];
  closeMarkerWidth:number = 0;

  constructor(
    public _clientWO: WorkorderGRPCService,
    public _mapSharedUtilService: MapSharedUtilService,
  ){ 
    const sub = this._clientWO.RXselectedWOIDsShared.subscribe((data) => {
      this.selectedWorkOrders.set(data);
      this.refreshMarkers();

    })
    this.subscriptions.push(sub);
  }
  ngOnDestroy(): void {
    this.subscriptions.map((item) => item.unsubscribe());
  }
  

  spiderLegs:any[] = [];
  spiderfy(latLng, features) {
    if(this.isActive) {
      return;
    }
    // remove any existing spider effect. 
    this.unspiderfy();
    
    // number of work orders present.
    const featuresCount = features.length;
    // get map instance
    const thisMap = this._mapSharedUtilService.mapInstanceGet;
    
    // generate spider leg elements
    let spiderLegParams = this.generateSpiderLegParams(featuresCount);

    // generate spider elements
    this.spiderLegs = features.map((feature, index) => {
      let param = spiderLegParams[index];
      const elements = this.createMarkerElements(param, feature, featuresCount, latLng);
      const maplibreMarker = new maplibregl.Marker({
        element: elements.container,
      }).setLngLat(latLng); 

      const spiderLeg = {
        feature,
        elements,
        maplibreMarker,
        param
      };
      return spiderLeg;
    });

    // add spider markers on the map
    const spiderLeds = this.spiderLegs.reverse();
    for (let i = 0; i < spiderLeds.length; i++) {
      this.spiderLegs[i].maplibreMarker.addTo(thisMap)
    }

    // create a close element
    // this element will be responisble for closing the spiderfy effect
    const closeElem = this.getSpiderMarkerContainerElem();
    // add close marker to the map
    this.closeMarker = new maplibregl.Marker({
      element: closeElem
    }).setLngLat(latLng).addTo(thisMap);

    this.isActive = true;
  }

  unspiderfy() {
    this.isActive = false;
    this.spiderLegs.forEach((spiderLeg, index) => {
      spiderLeg.maplibreMarker.remove();
    });
  }

  generateSpiderLegParams(count) {
    const circleSpiralSwitchover = 10;
    if (count >= circleSpiralSwitchover) {
      return this.generateSpiralParams(count);
    } else {
      return this.generateCircleParams(count);
    }
  }
  generateSpiralParams(count) {
    let legLength = 15;
    let angle = 0;
    const twoPi = Math.PI * 2;
    return this.mapTimesFn(count, (index) => {
      angle = angle + (28 / legLength + index * 0.0005);
      const pt = {
        x: legLength * Math.cos(angle),
        y: legLength * Math.sin(angle),
        angle: angle,
        legLength: legLength,
        index: index
      };
      legLength = legLength + (twoPi * 4 / angle);
      this.closeMarkerWidth = (legLength * 2);
      return pt;
    });
  }

  generateCircleParams(count) {
    const twoPi = Math.PI * 2;
    const circumference = 100 * (2 + count);
    const legLength = circumference / twoPi; // = radius from circumference
    const angleStep = twoPi / count;

    this.closeMarkerWidth = (legLength * 2);

    return this.mapTimesFn(count, (index) => {
      const angle = index * angleStep;
      return {
        x: legLength * Math.cos(angle),
        y: legLength * Math.sin(angle),
        angle: angle,
        legLength: legLength,
        index: index
      };
    });
  }

  createMarkerElements(spiderLegParam, feature, count, coords) {

    const thisMap = this._mapSharedUtilService.mapInstanceGet;
    // spider element container
    const containerElem = document.createElement('div');
    containerElem.className = 'spider-leg-container';
    
    containerElem.style.marginLeft = spiderLegParam.x + 'px';
    containerElem.style.marginTop = spiderLegParam.y + 'px';


    // spider element child - work order pin elem
    const  pinElem = document.createElement('div');
    pinElem.className = 'spider-leg-pin default-spider-pin'; 
    pinElem.id = 'pin-' + feature.name; 
    const isSelected = this.selectedSet().has(feature.name);
    // background color logic - WOStatusWeb.ReadyForDispatch == true ? '#' + ReadyForDispatchColor.P_888888 :   '#' + IconColour';
    pinElem.style.backgroundColor = feature.StatusWeb === WOStatusWeb.ReadyForDispatch ? '#' + ReadyForDispatchColor.P_888888 : feature.StatusWeb === WOStatusWeb.UTC ? '#000000' : '#' + feature.iconColour ;
    
    // outline color logic - WOStatusWeb.RecallRequested == true ? gray :   isSelected ? red :  '#' + TaskStatusColour';
    pinElem.style.outlineColor = feature.StatusWeb === WOStatusWeb.RecallRequested ? 'gray' : isSelected ? 'red': '#' + feature.taskStatusColour;
    
    pinElem.style.outlineWidth = '3px';
    pinElem.style.outlineStyle = 'solid';

    const tooltipElem = document.createElement('div');
    tooltipElem.className = 'tooltiptext'; 
    tooltipElem.innerHTML = this.getTooltipHtmlContent(feature);

    tooltipElem.onmouseenter  = (e) => {
      this.isTooltipActive = true;
    }
    tooltipElem.onmouseleave  = (e) => {
      this.isTooltipActive = false;
      // Add a delay so other process can run first
      setTimeout(() => {
        this.canCloseSpiderfy();
      }, 200);
    }
    pinElem.appendChild(tooltipElem);

    pinElem.oncontextmenu = (e) => {
      // remove existing popup;
      this.mappopupRef?.remove();
      const popupContent = this.getHtmlContent(feature, count);
      this.mappopupRef = new maplibregl.Popup()
        .setLngLat(coords)
        .setHTML(popupContent)
        .addTo(thisMap);
    };

    pinElem.onclick = (e) => {
      if(this._mapSharedUtilService.singlePointSelection)  {
        let selection = [...this.selectedWorkOrders()];
        const selectedWOIDsSet = new Set(selection.map(feature => feature.name));
        const isSelected = selectedWOIDsSet.has(feature.name);
        if(isSelected) {
          selection = selection.filter(obj => obj.name !== feature.name);
        } else { 
          selection.push(feature);
        }
        this._clientWO.RXselectedWOIDsShared.next(selection);
      }
    };
    // spider element child - spider leg elem
    const lineElem = document.createElement('div');
    lineElem.className = 'spider-leg-line';
    lineElem.style.height = spiderLegParam.legLength + 'px';
    lineElem.style.transform = 'rotate(' + (spiderLegParam.angle - Math.PI / 2) + 'rad)';
    lineElem.oncontextmenu = (e) => {
      this.mappopupRef?.remove();
      const popupContent = this.getHtmlContent(feature, count);
      this.mappopupRef = new maplibregl.Popup()
        .setLngLat(coords)
        .setHTML(popupContent)
        .addTo(thisMap);
    };

    containerElem.appendChild(lineElem);
    containerElem.appendChild(pinElem);

    containerElem.onmouseenter  = (e) => {
      this.isMarkerActive = true;
    }
    containerElem.onmouseleave  = (e) => {
      this.isMarkerActive = false;

      // Add a delay so other process can run first
      setTimeout(() => {
        this.canCloseSpiderfy();
      }, 200);
    }

    return { container: containerElem, line: lineElem, pin: pinElem };
  }
  mapTimesFn(count, iterator) {
    var result = [];
    for (var i = 0; i < count; i++) {
      result.push(iterator(i));
    }
    return result;
  }

  getHtmlContent(wo, count = 0) {
    let details = '';
    if (wo?.JsonData?.WorkOrder?.WorkOrderId) { details += `Work Order Id : ${wo?.JsonData?.WorkOrder?.WorkOrderId}<br>`; }
    if (wo?.StatusWeb) { details += `Status : ${wo?.StatusWeb}<br>`; }else{details += `Status : NA<br>`; }
    if (wo?.AssignedTo) { details += `FSR : ${wo?.AssignedTo}<br>`; }else { details += `FSR : NA<br>`; }
    if (wo?.JsonData?.ServicePoint?.Route) { details += `Route : ${wo?.JsonData?.ServicePoint?.Route}<br>`; }
    else { details += `Route : NA<br>`; }
    if (wo?.JsonData?.Contact?.Address) { details += `Address : ${wo?.JsonData?.Contact?.Address}<br>`; }
    else { details += `Address : NA<br>`; }
    if (wo?.JsonData?.WorkOrder?.TaskStatus) { details += `Task Status : ${wo?.JsonData?.WorkOrder?.TaskStatus}<br>`; }
    else { details += `Task Status : NA<br>`; }
    if (wo?.JsonData?.WorkOrder?.TaskId) { details += `Task ID : ${wo?.JsonData?.WorkOrder?.TaskId}<br>`; /*TODO: For hotfix in prod related to task 58365 */ }
    else { details += `Task ID : NA<br>`;}
    if (wo?.JsonData?.Asset?.MeterType || wo?.JsonData?.WorkOrder?.LegacyMeterForm/*TODO: For hotfix in prod where contract "NB Power 1153" use LegacyMeterForm*/) {
      details += `Meter Type : ${wo?.JsonData?.Asset?.MeterType || wo?.JsonData?.WorkOrder?.LegacyMeterForm}<br>`;
    }
    else { details += `Meter Type : NA<br>`;}
    if (count > 0) { details += `No. of Meters : ${count}<br>`; }
    else { details += `No. of Meters : NA<br>`; }
    return `<p> ${details} </p>`;
  }

  getSpiderMarkerContainerElem() {
    const element = document.createElement('div');
    element.innerHTML = ' '; 
    element.className = 'spider-marker'; 

    const extraWidth = 40;
    element.style.width =  (this.closeMarkerWidth + extraWidth) + 'px';
    element.style.height =  (this.closeMarkerWidth + extraWidth) + 'px';
    
    element.onmouseenter  = (e) => {
      this.isMouseOver = true;
    }
    element.onmouseleave  = (e) => {
      this.isMouseOver = false;
      // Add a delay so other process can run first
      // like - user moved to spider marker
      // like - user moved to spider marker popup
      // like - user moved to spider marker tooltip
      setTimeout(() => {
        this.canCloseSpiderfy();
      }, 200);
    }

    return element;
  } 

  getTooltipHtmlContent(wo) {
    let details = '';
    if (wo?.JsonData?.WorkOrder?.WorkOrderId) { details += `<div class="text-left">Work Order Id : ${wo?.JsonData?.WorkOrder?.WorkOrderId}</div>`; }
    if (wo?.StatusWeb) { details += `<div class="text-left">Status : ${wo?.StatusWeb}</div>`; }else{details += `<div>Status : NA</div>`; }
    details += `<div class="text-left"><a href="./details/${ wo.name }" target="_blank">Details</a></div>`;
    return `${details}`;
  }

  refreshMarkers() {
    this.spiderLegs.map((item) => {
      const feature = item.feature;
      const isSelected = this.selectedSet().has(feature.name);
      let itemElem = document.getElementById('pin-'+feature.name);
      if(itemElem) {
        
        // outline color logic - WOStatusWeb.RecallRequested == true ? gray :   isSelected ? red :  '#' + TaskStatusColour';
        itemElem.style.outlineColor = feature.StatusWeb === WOStatusWeb.RecallRequested ? 'gray' : isSelected ? 'red': '#' + feature.taskStatusColour;
      }
    })
  }

  canCloseSpiderfy() {
    if(this.isMarkerActive === false && this.isMouseOver === false  && this.isTooltipActive === false ) {
      this.unspiderfy();
      this.closeMarker?.remove();
    }
  }
}
